import { data } from '../../svg/Pending/data';
import { makeIcon } from '../makeIcon';

export const Pending = makeIcon(data, 'pending_actions', 'Pending');

export default Pending;
